const VoucherValue = {
  PRICE: 1,
  PERCENT: 2
}
export default VoucherValue
